module.exports = __webpack_public_path__ + "img/m_ic_sns_kakao.65f7ef3d.svg";